import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-forms-permissions",
    templateUrl: "./forms-permissions.component.html",
    styleUrl: "./forms-permissions.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormsPermissionsComponent {}
